import { render, staticRenderFns } from "./LinkAppleMusic.vue?vue&type=template&id=8a71a8ec&"
import script from "./LinkAppleMusic.vue?vue&type=script&lang=js&"
export * from "./LinkAppleMusic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports